<div class="flex flex-column gap-2" (contextmenu)="onRightClick($event, cm)">

    <!-- Removed. No longer using TreeNode -->
    <!--
    @if (selectedNode) {
        ...
    }
    -->

    @if (!initialized) {
        <p-skeleton width="100%" height="20rem"></p-skeleton>
    }

    @if (initialized) {

        <!-- ========================================= -->
                <!-- READ MODE                                -->
                <!-- ========================================= -->
        <div
                *ngIf="editorMode == 'read'"
                [attr.id]="sectionAnchorId"
                class="mb-4 border-round border-1 border-gray-200 text-sm text-color h-full img-full"
                style="line-height: 1.6; overflow-y: auto;">

            <!-- Header Section -->
            @if (sectionName) {
                <div class="flex justify-content-between align-items-center px-3 py-2 surface-100 border-1 border-300">
                    <div class="flex align-items-center gap-2">
                        <h4 class="m-0 font-semibold text-xl">{{ sectionName }}</h4>
                        @if (contentType === 'markdown') {
                            <p-tag value="Markdown" severity="info" [rounded]="true"></p-tag>
                        }
                    </div>

                    @if (currentIndex && totalSections) {
                        <span class="text-600">Section {{ currentIndex }}/{{ totalSections }}</span>
                    }
                </div>
            }

            <!-- Actual Read Mode Content -->
        @if (formattedContent) {
            <div #markdownContent
                 class="dc-docs p-3 surface-0"
                 [class.dc-markdown-content]="contentType === 'markdown'"
                 (click)="handleMentionClick($event)"
                 [innerHTML]="formattedContent | mvsSavePipe:'html'">
            </div>
        }


        </div>

        <!-- ========================================= -->
                <!-- EDIT MODE                                 -->
                <!-- ========================================= -->
        <div class="h-full"
             *ngIf="(quillForm && (editorMode == 'edit'))">

        @if (sectionName) {
            <div class="flex justify-content-between align-items-center px-3 py-2 surface-100 border-1 border-300">
                <h4 class="m-0 font-semibold text-xl">{{ sectionName }}</h4>
                @if (editorBusy) {
                    <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner>
                }
            </div>
        }

            <mvs-form-field-quill-editor
                    [formGroup]="quillForm"
                    [formField]="{id:'editorContent'}"
                    [pageId]="objectIdentifier.objectId"
                    (onSaveClick)="handleContentSave($event)"
                    (onCancelClick)="handleCancelClick()"
                    (onEditorBusy)="handleEditorBusy($event)"
                    class="h-full block"
            ></mvs-form-field-quill-editor>
        </div>
    }
</div>

<p-contextMenu #cm appendTo="body" [model]="contextMenuItems"></p-contextMenu>